var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CryptoJS from 'crypto-js';
import md5 from 'md5';
import Logger from 'src/utils/logger.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
const KEY_SIZE = 256;
const IV_SIZE = 128;
const ITERATIONS = 100;
const encryptJson = (content) => __awaiter(void 0, void 0, void 0, function* () {
    const ePass = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    content.hash = md5(content.list);
    const msg = yield encrypt(JSON.stringify(content), ePass);
    return msg;
});
const encrypt = (content, encryptPassword) => __awaiter(void 0, void 0, void 0, function* () {
    const ePass = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(ePass, salt, {
        keySize: KEY_SIZE / 32,
        iterations: ITERATIONS,
    });
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const encrypted = CryptoJS.AES.encrypt(content, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    });
    const encryptedMessage = salt.toString() + iv.toString() + encrypted.toString();
    return encryptedMessage;
});
function decrypt(transitmessage, pass) {
    var salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32));
    var encrypted = transitmessage.substring(64);
    var key = CryptoJS.PBKDF2(pass, salt, {
        keySize: KEY_SIZE / 32,
        iterations: ITERATIONS,
    });
    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    });
    return decrypted;
}
const decryptToJsonWithoutMD5Check = (msg, pwd) => {
    try {
        const decrypted = decrypt(msg, pwd).toString(CryptoJS.enc.Utf8);
        const decryptedJSON = JSON.parse(decrypted);
        if (decryptedJSON.hash != null)
            return decryptedJSON;
        else {
            Logger.error('decryptToJsonWithoutMD5Check: Invalid decrypted data: missing hash');
            return null;
        }
    }
    catch (e) {
        Logger.error('Error while decrypting', e);
        throw new Error(e);
    }
};
const decryptToJson = (msg, pwd) => {
    try {
        if (!msg) {
            Logger.error('decryptToJson: No encrypted data provided');
            return null;
        }
        const decrypted = decrypt(msg, pwd).toString(CryptoJS.enc.Utf8);
        const decryptedJSON = JSON.parse(decrypted);
        if (decryptedJSON.hash && decryptedJSON.list)
            return decryptedJSON;
        else {
            Logger.error('decryptToJson: Invalid decrypted data: missing hash or list');
            return null;
        }
    }
    catch (e) {
        Logger.error('Error while decrypting', e);
        return null;
    }
};
const hashPassword = (password) => {
    try {
        const hashed = md5(password);
        return hashed;
    }
    catch (error) {
        Logger.error('hashPassword: Error hashing password', error);
        throw error;
    }
};
const EncryptUtils = {
    encryptJson,
    encrypt,
    decryptToJson,
    decryptToJsonWithoutMD5Check,
    decrypt,
    hashPassword,
};
export default EncryptUtils;
